import { Link } from 'react-router-dom';
import home from '../../Asset/1943.jpg';
import React from 'react';

const Home = () => {
  return (
    <div>
      {/* Background Image with Fixed Effect */}
      <div
        className="bg-cover bg-center bg-fixed"
        style={{ backgroundImage: `url(${home})`, height: "600px" }}
      >
        {/* Dark Overlay with Blur Effect */}

        <div className="h-full w-full text-white backdrop-blur-sm bg-black/50 flex items-center px-4 md:px-8">
          <div className="max-w-screen-xl mx-auto w-full flex flex-col md:flex-row justify-between items-center gap-10">
          {/* Left Content Section */}
            <div className="w-full  flex flex-col justify-around space-y-6">
              <div>
                <h1 className="text-3xl sm:text-4xl md:text-3xl lg:text-4xl xl:text-5xl font-bold leading-tight">
                Power Up with 
                </h1>
                <h2 className="text-3xl sm:text-4xl md:text-3xl lg:text-4xl xl:text-5xl  font-bold leading-tight">
                Unmatched Steel Quality
                </h2>
                <h3 className='text-sm sm:text-base md:text-xl font-semibold mt-3'>
                Built on 10+ Years of Trust and Innovation
                </h3>
                <p className="text-sm sm:text-base md:text-lg font-medium mt-3">
                At Sai Steel, we don’t just supply steels — we deliver trust. Backed by 10 years of strong industry partnerships, expert service, and a commitment to quality, we provide only the finest steels products from top manufacturers.
                </p>
              </div>
              <div className="mt-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 max-w-xl p-4 rounded-xl border border-white bg-white/10">
                <div className="p-2">
                  <h2 className="text-3xl sm:text-4xl md:text-5xl font-semibold">10+</h2>
                  <p className="text-sm sm:text-base">YEARS EXPERIENCE</p>
                </div>
                <div className="p-2 text-left">
                  <p className="text-sm sm:text-base">
                  Choose Sai Steels for genuine products, reliable service, and confidence in every structure.
                  </p>
                  <Link to ="/about">
                  <button className="mt-3 px-4 py-2 text-black text-sm sm:text-base bg-white rounded-lg hover:bg-yellow-400 transition">
                    DISCOVER MORE
                  </button>
                  </Link>
                </div>
              </div>
            </div>
       {/* Right Side Image or Empty Section for now */}
            <div className="hidden md:block w-1/3 lg:w-1/2 text-black p-6 text-center">
              {/* Add image or any content here if needed */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
